import { createSlice } from '@reduxjs/toolkit';
import { queryApp, readApp } from './admin-app.thunk'

export const adminAppSlice = createSlice({
  name: 'admin-app',
  initialState: {
    // Using for swich section / pane
    activeSection: 'search',
    activePane: '',

    // Using for search section
    searchData: {
      filter: '',
      status: '',
      found: [{}],      
    },

    // Using for data entry section
    data: {}, // initialData(),
  },

  // Actions will be dispatched by app => store
  reducers: {
    setActiveSection: (state, action) => {
      state.activeSection = action.payload;
    },

    setActivePane: (state, action) => {
      state.activePane = action.payload;
    },

    setSearchData: (state, action) => {
      state.searchData = action.payload;
    },

  },

  extraReducers: (builder) => {
    builder.addCase(queryApp.fulfilled, (state, action) => {
      // console.info(action);
      state.searchData.found = action.payload;
    });

    builder.addCase(readApp.fulfilled, (state, action) => {
      // console.info(action);
      state.data = action.payload;
    });
  }
});

// Action creators are generated for each case reducer function
export const actions = adminAppSlice.actions;
export default adminAppSlice.reducer;
